import type { ReactNode } from 'react';

export interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

/**
 * Main page wrapper component with fade-in animation
 */
export function PageLayout({ children, className = '' }: PageLayoutProps) {
  return <div className={`animate-fadeIn ${className}`}>{children}</div>;
}
